
AGADash.Pagination = (function () {

    var getStatus = function (anyTarget) {
        var ul = $(anyTarget).closest(".pagination");
        return {
            "current": parseInt($(ul).attr("data-current")),
            "max": parseInt($(ul).attr("data-max"))
        };
    };

    var updateControl = function (anyTarget, newStatus) {
        var ul = $(anyTarget).closest(".pagination");
        var status = newStatus || getStatus(ul);

        // Atualizar prev button
        $(ul).children().first().toggleClass("disabled", status.current === 1);

        // Atualizar next button
        $(ul).children().last().toggleClass("disabled", status.current === status.max);

        $(ul).children().removeClass("active");
        $($(ul).children()[status.current]).addClass("active");

        // Atualizar linhas
        var table = $(ul).prev("table");

        var selector = 'tbody tr[pagenr="' + status.current.toString() + '"]';
        $(table).find("tbody tr").addClass("hide");
        $(table).find(selector).removeClass("hide");
    };

    var setStatus = function (anyTarget, status) {
        var ul = $(anyTarget).closest(".pagination");
        $(ul).attr({
            "data-current": status["current"],
            "data-max": status["max"]
        });
        updateControl(anyTarget, status);
    };

    var move = function (target, newPageNrFn) {
        var status = getStatus(target);
        if (status) {
            var newPos = newPageNrFn(status.current);
            if (newPos >= 1 && newPos <= status.max)
                status.current = newPos;
            setStatus(target, status);
        }
    }

    var movePrevious = function (e) {
        move(e.target, function (p) { return p - 1; });
    };

    var moveNext = function (e) {
        move(e.target, function (p) { return p + 1; });
    };

    var moveTo = function (anyTarget, pageNr) {
        move(anyTarget, function () { return pageNr });
    };

    var createPageButtonFull = function (parent, liClass, html, handler) {
        var li = document.createElement("li");
        if (liClass)
            $(li).addClass(liClass);
        $(li).appendTo(parent);
        var a = document.createElement("a");
        $(a).attr("href", "javascript:;").html(html).appendTo(li);
        $(a).on("click", handler);
        return li;
    };

    var createPageButton = function (parent, pageNr) {
        var c = pageNr === 1 ? "active" : undefined;
        var p = pageNr.toString();
        return createPageButtonFull(parent, c, " " + p + " ", function () {
            moveTo(this, pageNr);
        });
    };

    var createPageNav = function (parent, liClass, fa, handler) {
        var li = document.createElement("li");
        if (liClass)
            $(li).addClass(liClass);
        $(li).appendTo(parent);
        var a = document.createElement("a");
        $(a).attr("href", "javascript:;").appendTo(li);
        $(a).on("click", handler);
        var i = document.createElement("i");
        $(i).addClass("fa " + fa).appendTo(a);
        return li;
    };



    var paginate = function (tableElement, pageSize) {

        var trs = $(tableElement).find("tbody tr");
        var pageCount = 1;
        var pageItems = 0;
        if (!pageSize || pageSize < 1)
            pageSize = 10;

        if (trs.length <= pageSize)
            return;

        var container = document.createDocumentFragment();

        // botao prev
        createPageNav(container, "disabled", "fa-angle-left", movePrevious);
        createPageButton(container, 1);

        for (var index = 0; index < trs.length; index++) {
            if (pageItems === pageSize) {
                pageCount++;
                createPageButton(container, pageCount);
                pageItems = 0;
            }

            $(trs[index]).attr("pagenr", pageCount);
            if (pageCount > 1) {
                $(trs[index]).addClass("hide");
            }
            pageItems++;
        }

        // Botao next
        createPageNav(container, "", "fa-angle-right", moveNext);

        var ul = document.createElement("ul");
        $(ul).addClass("pagination pagination-sm");
        setStatus(ul, { current: 1, max: pageCount });
        ul.appendChild(container);
        $(tableElement).after(ul);
    };

    return {
        paginate: paginate
    };
})();
